const Modal = {
  baseStyle: {
    header: {
      p: '24px 24px 19px',
      borderBottom: '1px solid',
      borderBottomColor: 'gray.150',
    },
    closeButton: {
      top: '24px',
      right: '20px',
      borderRadius: 0,
      w: '22px',
      h: '22px',
      _hover: {
        bgColor: 'transparent',
      },
    },
    footer: {
      p: '16px 24px',
      justifyContent: 'flex-end',
      gap: '16px',
      borderTop: '1px solid',
      borderTopColor: 'gray.150',
    },
  },
}

export default Modal
